import React, { useState } from 'react';
import useStyles from './styles';
import PermissionGate from 'global/components/permission-gate';
import { Typography, Icon, Collapse } from '@material-ui/core';
import clsx from 'clsx';
import withRouter from 'react-router-dom/withRouter';
import AssessmentTemplates from './assessmenttemplates';
import EditionList from './editions';
import { Row, Column } from 'global/components/row';
import { useScreen } from 'global/styles';

export default PermissionGate(
  withRouter((props) => {
    const { isMobile } = useScreen();
    const classes = useStyles({ isMobile });
    const [state, setState] = useState({
      expanded: 'editions',
      panels: [
        { id: 'editions', title: 'Editions', component: (p) => <EditionList {...p} /> },
        // { id: 'scorecards', title: 'Scorecards', component: p => <AssessmentTemplates {...p} /> },
        { id: 'templates', title: 'Assessment Templates', component: (p) => <AssessmentTemplates {...p} /> },
      ],
    });

    return (
      <div className={classes.container}>
        <Column className={classes.accordion}>
          {state.panels.map((panel, i) => {
            const isOpen = state.expanded === panel.id;
            return (
              <Row key={i} fullWidth className={clsx('accordionRow', i !== state.panels.length - 1 ? 'notLast' : '')}>
                <Column fullWidth>
                  <Row className="titlerow" fullWidth onClick={() => setState((s) => ({ ...s, expanded: s.expanded === panel.id ? '' : panel.id }))}>
                    <Typography className={classes.heading}>{panel.title}</Typography>
                    <Icon>{isOpen ? 'expand_less' : 'expand_more'}</Icon>
                  </Row>
                  <Collapse style={{ width: '100%' }} in={isOpen}>
                    {isOpen && panel.component({})}
                  </Collapse>
                </Column>
              </Row>
            );
          })}
        </Column>
      </div>
    );
  })
);
